
import { mainStore, userActionStore, userToolStore } from '@/store';
import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component
export default class CheckAccessComponent extends Vue {
  @Prop({ type: String }) readonly propIs!: string;
  @Prop({ type: Boolean, default: false }) readonly colorize!: boolean;
  @Prop({ type: String, default: 'bottom' }) readonly position!: string;
  @Prop({ type: String, default: '300' }) readonly openDelay!: string;

  @Prop({ type: String, default: 'some' }) readonly verification!: string;
  @Prop({ type: String, default: 'disable' }) readonly behaviour!: string;
  @Prop({ type: Boolean, default: true })
  readonly hideTooltopWithAccess!: boolean;
  @Prop({ type: Boolean, default: true })
  readonly alwaysAllowSuperuser!: boolean;
  @Prop({ type: Object }) readonly tool!: any;
  @Prop({ type: String }) readonly action!: any;
  @Prop({ type: Number }) readonly roleId!: number;
  @Prop({ type: Number }) readonly departmentId!: number;
  @Prop({ type: Boolean, default: null }) readonly superuser!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly departmentIds!: number[];

  aux = true;

  get hide() {
    if (!this.hasAccess) {
      const hasSuperuserRule = !_.isNil(_.get(this, 'superuser'));
      if (hasSuperuserRule) {
        return hasSuperuserRule && !this.currentUser.is_superuser;
      }
      return this.behaviour === 'hide';
    }
  }

  get showTooltip() {
    if (this.currentUser.is_superuser) return true;
    return !this.hasAccess;
  }

  get fields() {
    return _.pickBy(this.options, (_k, v) => !_.isNil(_.get(this, v)));
  }

  get options() {
    return {
      tool: {
        hasAccess: _.get(this.toolField, (this.tool || {}).permission),
        description: `Permissão necessária: ${this.toolField.name} (${(this.tool || {}).permission})`,
      },
      action: {
        hasAccess: _.get(userActionStore, this.action),
        description: `Ação necessária: ${_.upperCase(_.join(_.words(this.action), ' '))}`,
      },
      roleId: {
        hasAccess: _.get(this.currentUser, 'role_id') == this.roleId,
        description: `Cargo necessário: ${this.roles[this.roleId]}`,
      },
      departmentId: {
        hasAccess: _.get(this.currentUser, 'departure_id') == this.departmentId,
        description: `Departamento necessário: ${this.departments[this.departmentId]}`,
      },
      departmentIds: {
        hasAccess: this.departmentIds.includes(_.get(this.currentUser, 'departure_id')),
        description: `Departamentos necessários: ${this.necessaryDepartaments}`,
      },
      superuser: {
        hasAccess: _.get(this.currentUser, 'is_superuser'),
        description: `Atributo necessário: Superusuário`,
      },
    };
  }

  get toolField(): any {
    return {
      name: '',
      ..._.find(
        userToolStore.currentUserTools,
        { tool_id: (this.tool || {}).id } || {
          allow_view: false,
          allow_edit: false,
          allow_delete: false,
          allow_create: false,
        }
      ),
    };
  }

  get hasAccess() {
    if (this.alwaysAllowSuperuser && this.currentUser.is_superuser) return true;
    const filters = _.map(_.values(this.fields), (v) => v.hasAccess);
    if (this.verification === 'some') {
      return _.some(filters);
    } else {
      return _.every(filters);
    }
  }

  get currentUser() {
    return mainStore.userProfile!;
  }

  get departments() {
    const obj = {};
    _.forEach(this.departureOptions(), (d) => {
      obj[d.id] = d.name;
    });
    return obj;
  }

  get roles() {
    const obj = {};
    _.forEach(this.roleOptions(), (d) => {
      obj[d.id] = d.name;
    });
    return obj;
  }

  get necessaryDepartaments() {
    let departamentNecessary = '';
    if (this.departmentIds) {
      let departments = [];
      for (let departmentId of this.departmentIds) {
        departments.push(this.departments[departmentId]);
      }
      departamentNecessary = departments.join(', ');
    }
    return departamentNecessary;
  }

  @Emit('click')
  handleClick() {
    return;
  }
}
